import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CustomSelectInput from '../../CustomSelectInput/CustomSelectInput';
import { XIcon } from '@phosphor-icons/react';
import Typhography from '../../Typhography/Typhography';
import { SelectChipsField, SelectOption } from '../types';

const SelectChipsFieldForm = ({ field }: { field: SelectChipsField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const currentError = _.get(errors, field.key);

  const getOptionValue = field.getOptionValue ?? ((opt: SelectOption) => opt.value);
  const getItemId = field.getItemId ?? ((item: any) => String(item._id ?? item.id ?? item));
  const getChipLabel = field.getChipLabel ?? ((item: any) => String(item.name ?? item.label ?? item));
  const getChipSubLabel = field.getChipSubLabel;
  const renderChipIcon = field.renderChipIcon;

  return (
    <Controller
      name={field.key}
      control={control}
      render={({ field: renderField }) => {
        const currentItems: any[] = renderField.value ?? [];

        const handleSelect = (option: any) => {
          const item = getOptionValue(option);
          if (!currentItems.some((i) => getItemId(i) === getItemId(item))) {
            const newItems = [...currentItems, item];
            renderField.onChange(newItems);
            field.onAfterChange?.(newItems, { setValue, getValues });
          }
        };

        const handleRemove = (item: any) => {
          renderField.onChange(
            currentItems.filter((i) => getItemId(i) !== getItemId(item))
          );
        };

        return (
          <div className="d-flex flex-column gap-2">
            <CustomSelectInput
              label={field.label}
              value={null}
              isDisabled={field.disabled as boolean}
              placeholder={field.placeholder}
              loadOptions={field.loadOptions as any}
              defaultOptions={field.defaultOptions}
              isOptionSelected={field.isOptionSelected ?? (() => false)}
              components={field.components}
              onChange={handleSelect}
            />

            {currentItems.length > 0 && (
              <div className="d-flex flex-column gap-1">
                <Typhography size="bold-12">
                  {currentItems.length} {field.chipsCountLabel ?? 'selezionati'}
                </Typhography>
                <div className="d-flex flex-wrap gap-2">
                  {currentItems.map((item) => (
                    <div
                      key={getItemId(item)}
                      className="d-flex align-items-center gap-1 px-2 py-1"
                      style={{
                        border: '1px solid #E7E7E7',
                        borderRadius: 8,
                        background: '#FBFBFB',
                      }}
                    >
                      {renderChipIcon?.(item)}
                      <Typhography size="medium-12">{getChipLabel(item)}</Typhography>
                      {getChipSubLabel && (
                        <Typhography size="medium-12" className="text-uppercase">
                          {getChipSubLabel(item)}
                        </Typhography>
                      )}
                      <XIcon
                        className="cursor-pointer"
                        style={{ fontSize: 14 }}
                        onClick={() => handleRemove(item)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {currentError && (
              <p className="text-danger" style={{ fontSize: 12 }}>
                {(currentError as any).message}
              </p>
            )}
          </div>
        );
      }}
    />
  );
};

export default SelectChipsFieldForm;
